export const DEFAULT_POST_LOGIN_PATH = '/';

export function isSafeInternalRedirect(value) {
  if (!value || typeof value !== 'string') return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value)) return false;
  return true;
}

export function getProtectedRouteTarget(pathname, search = '') {
  const target = `${pathname || '/'}${search || ''}`;
  return isSafeInternalRedirect(target) ? target : DEFAULT_POST_LOGIN_PATH;
}

export function buildLoginRedirect(target) {
  const safeTarget = isSafeInternalRedirect(target) ? target : DEFAULT_POST_LOGIN_PATH;
  return `/login?redirect=${encodeURIComponent(safeTarget)}`;
}

export function getRedirectFromLocation(search, fallback = DEFAULT_POST_LOGIN_PATH) {
  const params = new URLSearchParams(search || '');
  const redirect = params.get('redirect');
  return isSafeInternalRedirect(redirect) ? redirect : fallback;
}
